import React from "react";
import SettingsCard from "../../../components/structure/SettingsCard";
import OrganizationVariablesList from "./OrganizationVariablesList";
import OrganizationVariablesContainer from "../../../hooks/OrganizationVariablesContainer";

interface OrganizationVariablesSettingsProps {
    organizationId: string;
}

const OrganizationVariablesSettings: React.FC<OrganizationVariablesSettingsProps> = (props) => {

    if (!props.organizationId) {
        return <div>No organization ID provided</div>;
    }

    return (
        <OrganizationVariablesContainer.Provider>
            <SettingsCard title="Organization Constants">
                <OrganizationVariablesList organizationId={props.organizationId} />
            </SettingsCard>
        </OrganizationVariablesContainer.Provider>
    );
}

export default OrganizationVariablesSettings;
